// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Update checkbook'"></sub-header>

    <div class="big-info big-info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.account.productName}}
          </span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value">{{\$ctrl.account.balance | nxCurrency}}</span>
      </div>
    </div>

    <form name="\$ctrl.editForm">

      <table class="misc-transaction__table table">
        <tbody>
        <tr>
          <td></td>
          <td>Number of checks:</td>
          <td>
            <input
              class="value"
              type="number"
              required
              ng-model="\$ctrl.checkbook.checksCount"
              min="1"
              max="5000">
          </td>
        </tr>
        <tr>
          <td></td>
          <td>First check number:</td>
          <td>
            <input
              class="value"
              type="text"
              required
              ng-model="\$ctrl.checkbook.startNumber"
              ng-change="\$ctrl.onStartNumberChange()"
              ng-pattern="/^[0-9]*\$/"
              >
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Checkbook type:</td>
          <td>
            <select
              required
              class="form-control"
              ng-model="\$ctrl.checkbook.type"
              ng-options="t | prettyEnum for t in \$ctrl.checkbookTypes">
            </select>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="misc-transaction__control-buttons buttons">
        <button
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button
          class="btn btn-success"
          ng-click="\$ctrl.edit()"
          ng-disabled="\$ctrl.editForm.\$invalid">
          Update
        </button>
      </div>
    </form>

</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/checkbook/update/checkbook-update.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;